module.exports = __webpack_public_path__ + "img/stella_artois_lager_330ml.7f7b709e.png";